import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useReOrderChapter({ classID, courseID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function reOrderChapter(data) {
    return privateFetch
      .post(`/v1/admin/class/${classID}/course/${courseID}/chapter/re-order`, data)
      .then((res) => res.data);
  }

  return useMutation(reOrderChapter, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
    },
  });
}

export default useReOrderChapter;
